import { routePaths } from "App/routing";
import styles from './styles.module.scss';
import { dateFormatter, DateFormStyle } from 'lib/commonFunctions';
import { FormattedMessage } from "react-intl";
import { ArrowLink } from "components/Buttons/Button";
import { useHasPermission } from "hooks/useHasPermission";
import { Permissions } from "actions/roleActions";
import { ReportNotesAnswersDocument } from "components/ReportNotesAnswersDocument";
import { PDFDownloadLink } from '@react-pdf/renderer';
import { useLocation, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { usePopulateReportUserNotesAnswers } from "hooks/usePopulateReportUserNotesAnswers";
import { useUserState } from "context/user";


export const ReportHeader = () => {

  const { reportId } = useParams<{ reportId: string }>();
  const location = useLocation() as { state?: { getNotes?: boolean } };
  const getNotes = location.state?.getNotes ?? true;
  const queryClient = useQueryClient();

  const { reportUserNotesAnswers } = usePopulateReportUserNotesAnswers({
    reportId: reportId ?? null,
    getNotes,
    enabled: Boolean(reportId),
  });

  const hasPermission = useHasPermission();
  const { organizationTypeId } = useUserState();

  const clearReportQueries = () => {
    queryClient.removeQueries({ queryKey: ["reportUserNotesAnswersPopulate"], exact: false });
  };

  const dateSubmitted = reportUserNotesAnswers.report?.dateSubmitted;
  
  return (
      <div className={styles.reportHeader}>

        <ArrowLink to={routePaths.reports}
          onClick={clearReportQueries}
        > 
          <FormattedMessage id="reports" defaultMessage="Reports"/> 
        </ArrowLink>

        <div className={styles.reportTitleContainer}>
          <div className={styles.reportKeyAndDateSubmitted}>
            <h2 className={styles.reportKey}>{reportUserNotesAnswers.report?.reportKey}</h2>
            <span className={styles.dateSubmitted}>
              {dateSubmitted && dateFormatter(dateSubmitted, DateFormStyle.TextDateTime)}
            </span>
          </div>

           {hasPermission(Permissions.ViewReportDetails, reportUserNotesAnswers.report) && (
            <PDFDownloadLink 
              document={
                <ReportNotesAnswersDocument
                  reportUserNotesAnswers={reportUserNotesAnswers}
                  viewerOrganizationTypeId={organizationTypeId}
                />
              }
              style={{
                display: 'flex',
                textDecoration: 'underline',
                fontWeight: 800,
                flex: 1,
                padding: 10
              }}
              fileName={reportUserNotesAnswers.report?.reportKey + '.pdf'}
            >
              {({ blob, url, loading, error }: any) => { 
                if (loading) {
                  return (<FormattedMessage id="loading" defaultMessage="Loading"/>)
                } else {
                  return (<FormattedMessage id="buttons.download.report" defaultMessage="Download Report"/>);
                }
              }}
            </PDFDownloadLink>
          )} 
          
        </div>
      </div>
  );
}
